import { useI18n } from "@/contexts/I18nContext";

/**
 * Compact floating toolbar — top end of the screen.
 * Lets ANY user toggle language & theme instantly. Persists to localStorage.
 */
export default function TopToolbar() {
  const { lang, toggleLang, themeName, toggleTheme, theme, t, dir } = useI18n();

  const wrap = {
    position: "fixed",
    top: "12px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 9998,
    display: "flex",
    gap: "8px",
    fontFamily: "'Tajawal','Segoe UI',sans-serif",
  };

  const btn = {
    background: theme.surface,
    color: theme.text,
    border: `1px solid ${theme.border}`,
    padding: "8px 12px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: theme.name === "dark" ? "0 4px 12px rgba(0,0,0,0.35)" : "0 4px 12px rgba(0,0,0,0.08)",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 180ms ease",
  };

  return (
    <div style={wrap} data-testid="top-toolbar">
      <button
        type="button"
        onClick={toggleLang}
        style={btn}
        data-testid="toggle-language"
        title={t("toolbar.language")}
      >
        <span style={{ color: theme.gold }}>◐</span>
        {lang === "ar" ? "English" : "العربية"}
      </button>
      <button
        type="button"
        onClick={toggleTheme}
        style={btn}
        data-testid="toggle-theme"
        title={t("toolbar.theme")}
      >
        <span style={{ color: theme.gold }}>{themeName === "dark" ? "☀" : "☾"}</span>
        {themeName === "dark" ? t("toolbar.theme.light") : t("toolbar.theme.dark")}
      </button>
    </div>
  );
}
